import { classnames } from '@aibees/shared/utils';
import Highcharts from 'highcharts';
import PackedBubble from 'highcharts/highcharts-more';
import HighchartsReact from 'highcharts-react-official';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { PackedBubbleChartProps as Props } from './types';

PackedBubble(Highcharts);

export const PackedBubbleChart = memo(({ className, options }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('PackedBubbleChart', className)}
      sx={SX.root}
    >
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        constructorType={'chart'}
      />
    </Styled.Wrapper>
  );
});

PackedBubbleChart.displayName = 'PackedBubbleChart';
